import request from '@/config/axios'

export type VideoSeries = {
  id: number
  coverUrl: string
  name: string
  totalSeason: number
  description: string
}
export type VideoSeasons = {
  id: number
  seriesId?: number
  name: string
  episodesNum: number
}
export type VideoEpisodes = {
  id: number
  seriesId: number
  seasonId: number
  name: string
  coverUrl: string
  videoUrl: string
}

export const getVideoSeriesPage = (params: any) => {
  return request.get({
    url: '/video-series/page',
    params
  })
}

export const getVideoSeries = (id: any) => {
  return request.get({
    url: '/video-series/get?id=' + id
  })
}

export const getVideoSeasonsList = (seriesId: any) => {
  return request.get({
    url: '/video-seasons/list?seriesId=' + seriesId
  })
}

export const getVideoEpisodesList = (seriesId: any, seasonId: number) => {
  return request.get({
    url: '/video-episodes/list?seriesId=' + seriesId + '&seasonId=' + seasonId
  })
}
